export const HCCategoryIds = {
    REQUEST_HELP: 'REQUEST_HELP',
    HELP_DESK_TICKETS: 'HELP_DESK_TICKETS',
    RELEASE_NOTES: 'RELEASE_NOTES',
    LIVE_CHAT: 'LIVE_CHAT',
    TRAINING: 'TRAINING',
    BEST_PRACTICES: 'BEST_PRACTICES',
    ONLINE_RESOURCES: 'ONLINE_RESOURCES',
    DEBUG_DUMP: 'DEBUG_DUMP',
    LOCATIONS: 'LOCATIONS'
}

export const HCCategories = [
    {
        id: HCCategoryIds.REQUEST_HELP,
        name: 'Request Help',
        enabled: true
    },
    {
        id: HCCategoryIds.LOCATIONS,
        name: 'Locations',
        enabled: true
    },
    {
        id: HCCategoryIds.HELP_DESK_TICKETS,
        name: 'Help Desk Tickets',
        enabled: false
    },
    {
        id: HCCategoryIds.RELEASE_NOTES,
        name: 'Release Notes',
        enabled: false
    },
    {
        id: HCCategoryIds.LIVE_CHAT,
        name: 'Live Chat',
        enabled: false
    },
    {
        id: HCCategoryIds.TRAINING,
        name: 'Training',
        enabled: false
    },
    {
        id: HCCategoryIds.BEST_PRACTICES,
        name: 'Best Practices',
        enabled: false
    },
    {
        id: HCCategoryIds.ONLINE_RESOURCES,
        name: 'Online Resources',
        enabled: false
    },
    {
        id: HCCategoryIds.DEBUG_DUMP,
        name: 'Debug Dump',
        enabled: process.env.REACT_APP_ENV !== 'production'
    }
]
